<template>
    <section>
        <div class="modal-mask" v-show="displayModalLodaer">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <slot name="header">
                            <h2 class="loader-title">Laden…</h2>
                        </slot>
                    </div>

                    <div class="modal-body">
                        <div class="spinner-wrapper">
                            <div class="percentage">
                                <slot name="body"></slot>
                            </div>
                            <span class="loader"></span>
                        </div>
                    </div>
                    <div class="close-btn" v-show="cloaseBtn">
                        <button type="button" class="btn btn-warning downloadBtn" @click="$emit('close')">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        // 'displayModalLodaer'
        displayModalLodaer: {
            type: Boolean,
            required: true
        },
        timeout: {
            type: Number,
            default: 0
        },
        onClose: {
            type: Function,
            default: null,
        }
    },
    data() {
        return {
            showModalLoader: true,
            cloaseBtn: false,
        }
    },
    methods: {
        closeModalWindow() {
            this.showModalLoader = false
        }
    },
    mounted() {
        if (this.timeout > 0) {
            setTimeout(() => {
                this.cloaseBtn = true
            }, this.timeout);
        }
    }
};
</script>

<style scoped>
section {
    color: black;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: min(280px, calc(100vw - 3rem));
    max-width: 280px;
    margin: 0 auto;
    padding: 1.25rem 1.5rem;
    background-color: #264271;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    box-sizing: border-box;
}

.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.loader-title,
.modal-header h2,
:slotted(.loader-title),
:slotted(h2) {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.modal-default-button {
    float: right;
}

.modal-header,
.modal-body {
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

/* Loader Styles */
.spinner-wrapper {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    margin: 0.75rem auto;
    width: 56px;
    height: 56px;
}

.percentage {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    font-size: 0.85rem;
}

.loader {
    width: 48px;
    height: 48px;
    border: 3px solid #fff;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

.loader::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 3px solid;
    border-color: #ff3d00 transparent;
}

.close-btn {
    display: flex;
    justify-content: center;
    align-items: center;
}



@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
